'use strict';

angular.module('licensure.services')
    .factory('MergeContactGroups', ['$http', '$q', function ($http, $q) {
        return {
            get: function (code) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/MergeContactGroups', {
                        params: {
                            code: code
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/MergeContactGroups/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;